import React from 'react';
import { StyledButton, ButtonRules } from '@canopysecurity/component-library';

interface DeviceData {
  canopyDeviceId?: string;
  serialNumber?: string;
  status?: string;
  downloadStatus?: string;
  installStatus?: string;
  states?: {
    download?: Array<{ status: string }>;
    install?: Array<{ status: string }>;
  };
}

interface ExportCsvProps {
  data: DeviceData[];
  filename?: string;
}

const ExportCsv: React.FC<ExportCsvProps> = ({
  data,
  filename = 'export.csv',
}) => {
  const handleExport = () => {
    if (!data || data.length === 0) {
      console.error('No data to export');
      return;
    }

    const flattenedData = data.map((item) => {
      const downloadStatus =
        item.states?.download && item.states?.download.length > 0
          ? item.states.download[item.states.download.length - 1]?.status ||
            'N/A'
          : 'N/A';

      const installStatus =
        item.states?.install && item.states?.install.length > 0
          ? item.states.install[item.states.install.length - 1]?.status || 'N/A'
          : 'N/A';

      return {
        canopyDeviceId: item.canopyDeviceId || '',
        serialNumber: item.serialNumber || '',
        status: item.status || '',
        downloadStatus: item.downloadStatus || downloadStatus,
        installStatus: item.installStatus || installStatus,
      } as Record<string, string>;
    });

    const headers = Object.keys(flattenedData[0]);

    const csvContent = [
      [
        'Device ID',
        'Serial Number',
        'Overall Status',
        'Latest Download Status',
        'Latest Install Status',
      ].join(','),
      ...flattenedData.map((item) =>
        headers
          .map((header) => {
            const value = item[header];

            return `"${
              value === null || value === undefined
                ? ''
                : String(value).replace(/"/g, '""')
            }"`;
          })
          .join(','),
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <StyledButton buttonRules={ButtonRules.primaryA} onPress={handleExport}>
      Export to CSV
    </StyledButton>
  );
};

export default ExportCsv;
